import React from 'react';
import {observable, action, computed, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import s from '../../s';
import * as util from '../../../util';
import {CAFMat_Customization, MatCustomization} from '../../i';
import * as emitter from '../../../global/emitter';
import AbTestStore, {ABTestKeys} from '../../../global/store/ab-test.store';
import ModalSimple from '../../../global/modal-simple';
import InfoIcon from '.././shared/info-icon';
import {MatList} from './components/mat-list';
import {screenResizeStore} from '../../../global/store/screen-resize-store';

declare const bootstrap: any;
declare const window: any;

@observer
export default class Mat extends React.Component {
    max_mats: number = 6;
    max_mats_bg: number = 12;
    @observable collapsed: boolean = true;
    @observable collapsed_number: number = this.max_mats;

    @observable collapsed_mat2: boolean = true;
    @observable collapsed_number_mat2: number = this.max_mats;

    @observable collapsed_mat3: boolean = true;
    @observable collapsed_number_mat3: number = this.max_mats_bg;

    @observable fpc_id: number = -2;

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    abForceUpdate = async () => {
        this.forceUpdate();
        this.collapsed_number = this.max_mats;
        this.collapsed_number_mat2 = this.max_mats - 1;
        this.collapsed_number_mat3 = this.max_mats;

        if (s.prod.IsCAF) {
            if (AbTestStore.ABIsVariant(ABTestKeys.caf_single, 1)) {
                this.save(348);
                this.save(385);
            } else if (AbTestStore.ABIsVariant(ABTestKeys.caf_single, 2)) {
                this.save(12910);
                this.save(391);
            }
        }
    };

    componentDidMount(): void {
        emitter.eventEmitter.subscribe(emitter.EventType.AB, 'ab', this.abForceUpdate);
        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
            popoverTriggerEl.addEventListener('click', e => {
                const elements = document.getElementsByClassName('popover bs-popover-auto') as HTMLCollectionOf<HTMLElement>;
                Array.from(elements).forEach(i => (i.style.display = 'none'));
            });
            return new bootstrap.Popover(popoverTriggerEl);
        });

        if (s.prod.IsCAF) {
            if (AbTestStore.ABIsVariant(ABTestKeys.caf_single, 1)) {
                this.save(348);
                this.save(385);
            } else if (AbTestStore.ABIsVariant(ABTestKeys.caf_single, 2)) {
                this.save(13099);
            }
        }
    }

    @action
    collapseToggle = async () => {
        this.collapsed = !this.collapsed;
        this.collapsed_number = this.collapsed ? this.max_mats : 1000;
    };

    @action
    collapseToggle_mat2 = async () => {
        this.collapsed_mat2 = !this.collapsed_mat2;
        this.collapsed_number_mat2 = this.collapsed_mat2 ? this.max_mats : 1000;
    };

    @action
    collapseToggle_mat3 = async () => {
        this.collapsed_mat3 = !this.collapsed_mat3;
        this.collapsed_number_mat3 = this.collapsed_mat3 ? this.max_mats_bg : 1000;
    };

    @action
    save = async (id: number) => {
        util.prod_entity_zoom_destroy();
        if (!s.pcs.is_caf) {
            s.ui.update_pricing = true;
            s.pcs.matcombo_id = id;
            const m = s.prod.mats.filter(x => x.id === id)[0];
            s.pcs.mat1_id = m.mat1_id;
            s.pcs.mat2_id = m.mat2_id;
            s.pcs.mat1_color = m.pmat_color;
            s.pcs.mat2_color = m.smat_color;
            s.pcs.ins_gold_allowed = m.ins_gold_allowed;
            s.pcs.ins_silver_allowed = m.ins_silver_allowed;
            s.pcs.ins_black_allowed = m.ins_black_allowed;
            s.ui.doRender = true;

            if (m) {
                s.ui.linen = m.pmat_name.toLowerCase().includes('linen');
            }

            if (s.prod.CustomizationMethod === 1 && m.ImageName) {
                s.ui.old_style_composite = m.ImageName.toLowerCase();
            }

            s.pulse();
        } else {
            s.ui.update_pricing = true;
            const m1 = s.prod.caf_mat1.filter(x => x.id === id)[0];
            const m2 = s.prod.caf_mat2.filter(x => x.id === id)[0];
            if (m1) {
                s.pcs.mat1_id = m1.id;
                s.pcs.mat1_color = m1.mat_color;
                s.pcs.ins_gold_allowed = m1.ins_gold_allowed;
                s.pcs.ins_silver_allowed = m1.ins_silver_allowed;
                s.pcs.ins_black_allowed = m1.ins_black_allowed;

                // console.log(m1.name);
                // console.log(m1.name.toLowerCase().includes('linen'));
                if (m1) {
                    s.ui.linen = m1.name.toLowerCase().includes('linen');
                }
            } else if (m2) {
                s.pcs.mat2_id = m2.id;
                s.pcs.mat2_color = m2.mat_color;
            }

            if (id === -1) {
                s.pcs.mat2_id = -1;
                s.pcs.mat2_color = '';
                s.ui.name_mat2 = 'No Inner Accent';
                s.ui.color_mat2 = '';
                s.ui.title_mat2 = 'No Inner Accent';
            }

            s.ui.doRender = true;
            s.pulse();
        }

        if (window.innerWidth < 1200) {
            const d = document.getElementById('prod-header') as HTMLDivElement;
            d.scrollIntoView();
        }
    };

    @action
    save_vlbg = async (id: number) => {
        const m2 = s.prod.caf_mat2.filter(x => x.id === id)[0];
        if (m2) {
            s.pcs.vlbg_id = id;
            s.pcs.vlbg_color = m2.mat_color;
            s.ui.title_vlbg = m2.title;
            s.ui.doRender = true;
            s.pulse();

            if (window.innerWidth < 1200) {
                const d = document.getElementById('prod-header') as HTMLDivElement;
                d.scrollIntoView();
            }
        }
    };

    @action
    changeCategory = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.fpc_id = parseInt(e.target.value);
    };

    @computed get canCollapse(): boolean {
        return s.pcs.is_caf || this.isMobile;
    }

    @computed get isMobile(): boolean {
        return screenResizeStore.width < 960;
    }

    render() {
        if (!s.ready || !s.ui.show_cust) {
            return;
        }

        if (!s.pcs.is_caf && s.prod.mats) {
            if (s.prod.mats.length > 1) {
                return (
                    <div
                        className="gray-box"
                        style={{padding: 0}}
                    >
                        <div>
                            <div>
                                <div
                                    style={{
                                        padding: '0 12px',
                                        position: 'relative',
                                    }}
                                >
                                    <div
                                        role={this.canCollapse ? 'button' : undefined}
                                        tabIndex={this.canCollapse ? 0 : undefined}
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                e.currentTarget.click();
                                            }
                                        }}
                                        className="d-none d-xl-block toggle-bs"
                                        data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                        data-bs-target="#mat1-inner"
                                        aria-expanded={this.canCollapse ? false : undefined}
                                        aria-controls={this.canCollapse ? 'mat1-inner' : undefined}
                                    >
                                        <div className="cust-desktop-head">
                                            <span>Matting: </span>
                                            <span>{s.ui.title_mat_combo}</span>
                                        </div>
                                    </div>

                                    <div
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                e.currentTarget.click();
                                            }
                                        }}
                                        className="d-block d-xl-none toggle-bs"
                                        data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                        data-bs-target="#mat1-inner"
                                        aria-expanded={this.canCollapse ? false : undefined}
                                        aria-controls={this.canCollapse ? 'mat1-inner' : undefined}
                                    >
                                        <div className="cust-flex-head">
                                            <div>
                                                <div
                                                    className="header-std flexer cust-flex2"
                                                    style={{paddingRight: '0.25rem'}}
                                                >
                                                    Matting
                                                </div>
                                                <div className="cust-flex2">{s.ui.title_mat_combo}</div>
                                            </div>
                                            <div>
                                                {this.canCollapse &&
                                                    this.collapsed &&
                                                    s.prod.mats
                                                        .filter(m => m.id === s.pcs.matcombo_id)
                                                        .map((m: MatCustomization, i: number) => (
                                                            <img
                                                                key={i}
                                                                src={`https://${s.Portal.CDNDomain}/images/entities/matcombos/90_${m.mat1_id}${m.mat2_id && m.mat2_id > 0 ? `_${m.mat2_id.toString()}` : ''}.png`}
                                                                alt={m.title}
                                                            />
                                                        ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: this.isMobile ? 6 : 5,
                                            left: this.isMobile ? 72 : 'auto',
                                            right: !this.canCollapse ? 8 : 'auto',
                                        }}
                                    >
                                        <InfoIcon
                                            id="modal-matting"
                                            ariaLabel="Open dialog with matting information for this product"
                                            useMargin={true}
                                            styleBlack={true}
                                        />
                                    </div>
                                </div>
                                <div
                                    id="mat1-inner"
                                    className={this.canCollapse ? 'collapse' : ''}
                                    style={{padding: '0 12px'}}
                                >
                                    <MatList
                                        collapsed={this.collapsed}
                                        collapsedNumber={this.collapsed_number}
                                        save={this.save}
                                    />

                                    {s.prod.mats.length > this.max_mats && (
                                        <button
                                            className="btn btn-outline-secondary btn-sm btn-toggle"
                                            onClick={this.collapseToggle}
                                            style={{margin: '4px 0 2px 0', color: '#000000', display: 'flex', justifySelf: 'center'}}
                                            aria-label={this.collapsed ? `+ View all ${s.prod.mats.length} mats` : '- View less mats'}
                                        >
                                            {this.collapsed ? `+ View all ${s.prod.mats.length} mats` : '- View less mats'}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        <ModalSimple
                            id="modal-matting"
                            title="Matting Information"
                        >
                            <p>
                                Frame mats, or matting, are the decorative borders that surround your diploma or certificate within the frame, adding depth and elegance while protecting your document. Our premium mats are made from "conservation quality" materials that are 100% acid- and
                                lignin-free, ensuring your achievement is preserved safely over time without yellowing or damage. Professionally bevel-cut for a clean and polished look, our mats are available in a wide range of colors and textures, allowing you to customize the style to complement
                                your document and frame perfectly.
                            </p>
                        </ModalSimple>
                    </div>
                );
            } else {
                return;
            }
        } else {
            return (
                <div>
                    {s.prod.caf_mat1 && (
                        <div
                            className="gray-box"
                            style={{padding: 0}}
                        >
                            <div>
                                <div>
                                    <div
                                        style={{
                                            padding: '0 12px',
                                            position: 'relative',
                                        }}
                                    >
                                        <div
                                            role={this.canCollapse ? 'button' : undefined}
                                            tabIndex={this.canCollapse ? 0 : undefined}
                                            onKeyDown={e => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    e.currentTarget.click();
                                                }
                                            }}
                                            className="d-none d-xl-block toggle-bs"
                                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                            data-bs-target="#mat1-inner"
                                            aria-expanded={this.canCollapse ? false : undefined}
                                            aria-controls={this.canCollapse ? 'mat1-inner' : undefined}
                                        >
                                            <div className="cust-desktop-head">
                                                <span>Top Mat: </span>
                                                <span>{s.ui.title_mat1}</span>
                                            </div>
                                        </div>

                                        <div
                                            role="button"
                                            tabIndex={0}
                                            onKeyDown={e => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    e.currentTarget.click();
                                                }
                                            }}
                                            className="d-block d-xl-none toggle-bs"
                                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                            data-bs-target="#mat1-inner"
                                            aria-expanded={this.canCollapse ? false : undefined}
                                            aria-controls={this.canCollapse ? 'mat1-inner' : undefined}
                                        >
                                            <div className="cust-flex-head">
                                                <div>
                                                    <div
                                                        className="header-std flexer cust-flex2"
                                                        style={{paddingRight: '0.25rem'}}
                                                    >
                                                        Top Mat
                                                    </div>
                                                    <div className="cust-flex2">{s.ui.title_mat1}</div>
                                                </div>
                                                <div>
                                                    {this.canCollapse &&
                                                        this.collapsed &&
                                                        s.prod.caf_mat1
                                                            .filter(m => m.id === s.pcs.mat1_id)
                                                            .map((m: CAFMat_Customization, i: number) => (
                                                                <img
                                                                    key={i}
                                                                    src={`https://${s.Portal.CDNDomain}/images/entities/matcombos/90_${m.id}.png`}
                                                                    alt={m.title}
                                                                />
                                                            ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        id="mat1-inner"
                                        className={this.canCollapse ? 'collapse' : ''}
                                        style={{padding: '0 12px'}}
                                    >
                                        <div>
                                            <select
                                                className="cust-entity"
                                                aria-label="Select category"
                                                onChange={this.changeCategory}
                                            >
                                                {s.prod.caf_mat1.length > 0 && <option value={-2}>All</option>}
                                                {s.prod.caf_mat1.filter(m => m.fpc_id === 12).length > 0 && <option value={12}>Standard</option>}
                                                {s.prod.caf_mat1.filter(m => m.fpc_id === 13).length > 0 && <option value={13}>Suede</option>}
                                                {s.prod.caf_mat1.filter(m => m.fpc_id === 14).length > 0 && <option value={14}>Linen</option>}
                                            </select>
                                        </div>
                                        <div
                                            className="caf-mat-prod"
                                            role="listbox"
                                            aria-label="Select matting"
                                        >
                                            {s.prod.caf_mat1
                                                .slice(0, 1000)
                                                .filter(m => m.fpc_id === this.fpc_id || this.fpc_id === -2)
                                                .slice(0, this.collapsed_number)
                                                .map((m: CAFMat_Customization, i: number) => (
                                                    <div
                                                        data-bs-toggle={window.innerWidth > 1200 ? 'popover' : ''}
                                                        data-bs-placement="top"
                                                        data-bs-html="true"
                                                        data-bs-trigger="hover focus"
                                                        data-bs-content={`<div class="prod-img-zoom"><img src="https://${s.Portal.CDNDomain}/images/entities/matcombos/220_${m.id}.png" alt="" /></div>`}
                                                        title={m.title}
                                                        id={`mat1-${m.id}`}
                                                        role="option"
                                                        key={m.id}
                                                        aria-label={`Select ${m.title} mat`}
                                                        data-img={`https://${s.Portal.CDNDomain}/images/entities/matcombos/220_${m.id}.png`}
                                                        className={`cust-entity${s.pcs.mat1_id === m.id ? ' active' : ''}${!this.collapsed ? ' active-bold' : ''}`}
                                                        data-id={m.id}
                                                        onClick={() => this.save(m.id)}
                                                        onKeyDown={e => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                this.save(m.id);
                                                            }
                                                        }}
                                                        tabIndex={0}
                                                    >
                                                        <img
                                                            src={`https://${s.Portal.CDNDomain}/images/entities/matcombos/90_${m.id}.png`}
                                                            data-id={m.id}
                                                            alt={m.title}
                                                            loading="lazy"
                                                            className="prod-option caf_mat2"
                                                            data-img={`https://${s.Portal.CDNDomain}/images/entities/matcombos/220_${m.id}.png`}
                                                        />
                                                        <div
                                                            className="title"
                                                            data-id={m.id}
                                                            data-img={`https://${s.Portal.CDNDomain}/images/entities/matcombos/220_${m.id}.png`}
                                                        >
                                                            {m.title}
                                                        </div>
                                                        {s.pcs.mat1_id === m.id && (
                                                            <div
                                                                className="mat-highlight"
                                                                style={{
                                                                    backgroundColor: s.pcs.mat2_id > 0 ? `#${s.pcs.mat2_color}` : 'none',
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                        </div>
                                        {s.prod.caf_mat1.length > this.max_mats && (
                                            <button
                                                className="btn btn-outline-secondary btn-sm btn-toggle"
                                                onClick={this.collapseToggle}
                                                style={{margin: '4px 0 2px 0', color: '#000000', display: 'flex', justifySelf: 'center'}}
                                                aria-label={this.collapsed ? `+ View all ${s.prod.caf_mat1.filter(m => m.fpc_id === this.fpc_id || this.fpc_id === -2).length} mats` : '- View less mats'}
                                            >
                                                {this.collapsed ? `+ View all ${s.prod.caf_mat1.filter(m => m.fpc_id === this.fpc_id || this.fpc_id === -2).length} mats` : '- View less mats'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {s.prod.caf_mat2 && (
                        <div
                            className="gray-box"
                            style={{marginTop: '0.5rem', padding: 0}}
                        >
                            <div>
                                <div>
                                    <div
                                        style={{
                                            padding: '0 12px',
                                            position: 'relative',
                                        }}
                                    >
                                        <div
                                            role={this.canCollapse ? 'button' : undefined}
                                            tabIndex={this.canCollapse ? 0 : undefined}
                                            onKeyDown={e => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    e.currentTarget.click();
                                                }
                                            }}
                                            className="d-none d-xl-block toggle-bs"
                                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                            data-bs-target="#mat2-inner"
                                            aria-expanded={this.canCollapse ? false : undefined}
                                            aria-controls={this.canCollapse ? 'mat2-inner' : undefined}
                                        >
                                            <div className="cust-desktop-head">
                                                <span>Inner Accent: </span>
                                                <span>{s.ui.title_mat2}</span>
                                            </div>
                                        </div>

                                        <div
                                            role="button"
                                            tabIndex={0}
                                            onKeyDown={e => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    e.currentTarget.click();
                                                }
                                            }}
                                            className="d-block d-xl-none toggle-bs"
                                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                            data-bs-target="#mat2-inner"
                                            aria-expanded={this.canCollapse ? false : undefined}
                                            aria-controls={this.canCollapse ? 'mat2-inner' : undefined}
                                        >
                                            <div className="cust-flex-head">
                                                <div>
                                                    <div
                                                        className="header-std flexer cust-flex2"
                                                        style={{paddingRight: '0.25rem'}}
                                                    >
                                                        Inner Accent
                                                    </div>
                                                    <div className="cust-flex2">{s.ui.title_mat2}</div>
                                                </div>
                                                <div>
                                                    {this.canCollapse &&
                                                        this.collapsed &&
                                                        s.prod.caf_mat2
                                                            .filter(m => m.id === s.pcs.mat2_id)
                                                            .map((m: CAFMat_Customization, i: number) => (
                                                                <img
                                                                    key={i}
                                                                    src={`https://${s.Portal.CDNDomain}/images/entities/secondarymat/${m.name}_thumb_90.png`}
                                                                    alt={m.title}
                                                                />
                                                            ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        id="mat2-inner"
                                        className={this.canCollapse ? 'collapse' : ''}
                                        style={{padding: '0 12px'}}
                                    >
                                        <div
                                            className="caf-mat-prod"
                                            role="listbox"
                                            aria-label="Select matting"
                                        >
                                            <div
                                                title={'No Inner Accent'}
                                                id={`mat2-${-1}`}
                                                role="option"
                                                data-id={-1}
                                                key={-1}
                                                aria-label={`Remove inner accent`}
                                                className={`cust-entity${s.pcs.mat2_id === -1 ? ' active' : ''}${!this.collapsed_mat2 ? ' active-bold' : ''}`}
                                                onClick={() => this.save(-1)}
                                                onKeyDown={e => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        this.save(-1);
                                                    }
                                                }}
                                                tabIndex={0}
                                            >
                                                <img
                                                    data-id={-1}
                                                    src={`https://${s.Portal.CDNDomain}/images/cached/general/dyf_no_secondarymat.png`}
                                                    alt={'No Inner Accent'}
                                                    className="prod-option caf_mat2"
                                                    loading="lazy"
                                                    data-img={`https://${s.Portal.CDNDomain}/images/cached/general/dyf_no_secondarymat.png`}
                                                />
                                                <div
                                                    className="title"
                                                    data-id={-1}
                                                    data-img={`https://${s.Portal.CDNDomain}/images/cached/general/dyf_no_secondarymat.png`}
                                                >
                                                    No Inner Accent
                                                </div>
                                                {s.pcs.mat2_id === -1 && (
                                                    <div
                                                        className="mat-highlight"
                                                        style={{
                                                            backgroundColor: s.pcs.mat1_id > 0 ? `#${s.pcs.mat1_color}` : 'none',
                                                        }}
                                                    />
                                                )}
                                            </div>

                                            {s.prod.caf_mat2
                                                .slice(0, 1000)
                                                .slice(0, this.collapsed_number_mat2)
                                                .map((m: CAFMat_Customization, i: number) => (
                                                    <div
                                                        data-bs-toggle={window.innerWidth > 1200 ? 'popover' : ''}
                                                        data-bs-placement="top"
                                                        data-bs-html="true"
                                                        data-bs-trigger="hover focus"
                                                        data-bs-content={`<div class="prod-img-zoom"><img src="https://${s.Portal.CDNDomain}/images/entities/secondarymat/${m.name}_thumb_220.png" alt="" /></div>`}
                                                        title={m.title}
                                                        id={`mat2-${m.id}`}
                                                        role="option"
                                                        data-id={m.id}
                                                        key={m.id}
                                                        aria-label={`Select ${m.title} mat`}
                                                        className={`cust-entity${s.pcs.mat2_id === m.id ? ' active' : ''}${!this.collapsed_mat2 ? ' active-bold' : ''}`}
                                                        onClick={() => this.save(m.id)}
                                                        onKeyDown={e => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                this.save(m.id);
                                                            }
                                                        }}
                                                        tabIndex={0}
                                                    >
                                                        <img
                                                            data-id={m.id}
                                                            src={`https://${s.Portal.CDNDomain}/images/entities/secondarymat/${m.name}_thumb_90.png`}
                                                            loading="lazy"
                                                            alt={m.title}
                                                            className="prod-option caf_mat2"
                                                            data-img={`https://${s.Portal.CDNDomain}/images/entities/secondarymat/${m.name}_thumb_220.png`}
                                                        />
                                                        <div
                                                            className="title"
                                                            data-id={m.id}
                                                            data-img={`https://${s.Portal.CDNDomain}/images/entities/secondarymat/${m.name}_thumb_220.png`}
                                                        >
                                                            {m.title}
                                                        </div>
                                                        {s.pcs.mat2_id === m.id && (
                                                            <div
                                                                className="mat-highlight"
                                                                style={{
                                                                    backgroundColor: s.pcs.mat1_id > 0 ? `#${s.pcs.mat1_color}` : 'none',
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                        </div>
                                        {s.prod.caf_mat2.length > this.max_mats && (
                                            <button
                                                className="btn btn-outline-secondary btn-sm btn-toggle"
                                                onClick={this.collapseToggle_mat2}
                                                style={{margin: '4px 0 2px 0', color: '#000000', display: 'flex', justifySelf: 'center'}}
                                                aria-label={this.collapsed ? `+ View all ${s.prod.caf_mat2.length} inner accents` : '- View less inner accents'}
                                            >
                                                {this.collapsed ? `+ View all ${s.prod.caf_mat2.length} inner accents` : '- View less inner accents'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {s.prod.DYF_FrameStyleID === 4 && (
                        <div
                            className="gray-box"
                            style={{marginTop: '0.5rem', padding: 0}}
                        >
                            <div>
                                <div>
                                    <div
                                        style={{
                                            padding: '0 12px',
                                            position: 'relative',
                                        }}
                                    >
                                        <div
                                            role={this.canCollapse ? 'button' : undefined}
                                            tabIndex={this.canCollapse ? 0 : undefined}
                                            onKeyDown={e => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    e.currentTarget.click();
                                                }
                                            }}
                                            className="d-none d-xl-block toggle-bs"
                                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                            data-bs-target="#mat3-inner"
                                            aria-expanded={this.canCollapse ? false : undefined}
                                            aria-controls={this.canCollapse ? 'mat3-inner' : undefined}
                                        >
                                            <div className="cust-desktop-head">
                                                <span>Background: </span>
                                                <span>{s.ui.title_vlbg}</span>
                                            </div>
                                        </div>

                                        <div
                                            className="d-block d-md-none toggle-bs"
                                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                            data-bs-target="#mat3-inner"
                                            aria-expanded={this.canCollapse ? false : undefined}
                                            aria-controls={this.canCollapse ? 'mat3-inner' : undefined}
                                        >
                                            <div className="cust-flex-head">
                                                <div>
                                                    <div
                                                        className="header-std flexer cust-flex2"
                                                        style={{paddingRight: '0.25rem'}}
                                                    >
                                                        Background
                                                    </div>
                                                    <div className="cust-flex2">{s.ui.title_vlbg}</div>
                                                </div>
                                                <div></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        id="mat3-inner"
                                        className={this.canCollapse ? 'collapse' : ''}
                                        style={{padding: '0 12px'}}
                                    >
                                        <div
                                            className="caf-mat-prod"
                                            role="listbox"
                                            aria-label="Select matting"
                                        >
                                            {s.prod.caf_mat2
                                                .slice(0, 1000)
                                                .slice(0, this.collapsed_number_mat3)
                                                .map((m: CAFMat_Customization, i: number) => (
                                                    <div
                                                        role="option"
                                                        key={m.id}
                                                        title={m.title}
                                                        aria-label={`Select ${m.title} mat`}
                                                        className={`cust-vlbg cust-entity${s.pcs.vlbg_id === m.id ? ' active' : ''}${!this.collapsed_mat3 ? ' active-bold' : ''}`}
                                                        onClick={() => this.save_vlbg(m.id)}
                                                        onKeyDown={e => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                this.save_vlbg(m.id);
                                                            }
                                                        }}
                                                        tabIndex={0}
                                                    >
                                                        <div
                                                            className="vlbg"
                                                            style={{
                                                                backgroundColor: `#${m.mat_color}`,
                                                            }}
                                                        />
                                                        <div
                                                            className="title"
                                                            data-id={m.id}
                                                            data-img={`https://${s.Portal.CDNDomain}/images/entities/secondarymat/${m.name.toLowerCase()}_thumb_220.png`}
                                                        >
                                                            {m.title}
                                                        </div>
                                                        {s.pcs.vlbg_id === m.id && (
                                                            <div
                                                                className="mat-highlight"
                                                                style={{
                                                                    backgroundColor: s.pcs.mat1_id > 0 ? `#${s.pcs.mat1_color}` : 'none',
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                        </div>
                                        {s.prod.caf_mat2.length > this.max_mats && (
                                            <button
                                                className="btn btn-outline-secondary btn-sm btn-toggle"
                                                onClick={this.collapseToggle_mat3}
                                                style={{margin: '4px 0 2px 0', color: '#000000', display: 'flex', justifySelf: 'center'}}
                                                aria-label={this.collapsed ? `+ View all ${s.prod.caf_mat2.length} backgrounds` : '- View less backgrounds'}
                                            >
                                                {this.collapsed ? `+ View all ${s.prod.caf_mat2.length} backgrounds` : '- View less backgrounds'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            );
        }
    }
}
